/**
 *
 */
export var OrderType;
(function (OrderType) {
    OrderType["DELIVERY"] = "Delivery";
    OrderType["PICKUP"] = "Pickup";
})(OrderType || (OrderType = {}));
/**
 *
 */
export var OrderDetailsText;
(function (OrderDetailsText) {
    OrderDetailsText["CHOOSE_MEALS"] = "Choose {meal_entity_name_plural}";
    OrderDetailsText["DELIVER_TO"] = "Deliver to";
    OrderDetailsText["GIFT_CARD_PURCHASE"] = "Gift Card Purchase";
    OrderDetailsText["INVOICE"] = "Invoice";
    OrderDetailsText["MEALS_NOT_SELECTED"] = "{meal_entity_name_plural} have not been selected for this day.";
    OrderDetailsText["ORDER_DETAILS"] = "Details";
    OrderDetailsText["ORDER_NUMBER"] = "Order #";
    OrderDetailsText["ORDER_PLACED"] = "Order placed";
    OrderDetailsText["ORDER_UPCOMING"] = "Order Upcoming";
    OrderDetailsText["PICKUP_AT"] = "Pickup at";
    OrderDetailsText["PROGRAM_ID"] = "Program Id";
    OrderDetailsText["PROGRAM_NAME"] = "Program name";
    OrderDetailsText["REVIEW_MEALS"] = "Review {meal_entity_name_plural}";
    OrderDetailsText["SUBSCRIPTION_ID"] = "Subscription #";
    OrderDetailsText["THE_WEEK_OF"] = "The week of";
    OrderDetailsText["TOTAL"] = "Total";
    OrderDetailsText["UPDATE_DELIVERY"] = "Update Delivery";
    OrderDetailsText["YOU_CAN_CHOOSE_MEALS"] = "You can choose your {meal_entity_name_plural} now.";
})(OrderDetailsText || (OrderDetailsText = {}));
export var DetailTexts;
(function (DetailTexts) {
    DetailTexts["DO_NOT_DISPLAY"] = "DO_NOT_DISPLAY";
    DetailTexts["GIFT_CARD"] = "Gift Card";
    DetailTexts["NO_ADDRESS"] = "No order address found!";
})(DetailTexts || (DetailTexts = {}));
